const newContact = (data) => ({
  method: "POST",
  url: "/contacts",
  data,
});

const getContactsList = ({ page, ...restData }) => ({
  method: "GET",
  url: `/contacts`,
  data: { ...restData, page: page + 1 },
});

const editContact = ({ id, ...data }) => ({
  method: "PUT",
  url: `/contacts/${id}`,
  data,
});

const getContacts = ({ companyId, ...data }) => ({
  method: "GET",
  url: `/contacts?company.id=${companyId}`,
  data,
});

const getContact = ({ contactId }) => ({
  method: "GET",
  url: `/contacts/${contactId}`,
});

const deleteContact = ({ id }) => ({
  method: "DELETE",
  url: `/contacts/${id}`,
});

export const contactApi = {
  newContact,
  getContacts,
  getContact,
  editContact,
  deleteContact,
  getContactsList,
};
